module.exports = __webpack_public_path__ + "static/media/QuickbookBack.87c5ff8f.jpeg";